﻿
import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { filter } from 'rxjs/operators'


export interface IBreadcrumb {
    label: string;
    params: Params;
    url: string;
}



@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html'
})
export class BreadCrumbComponent implements OnInit, OnDestroy {



    //#region properties

    @Input() public showHome: boolean = true;
    public breadcrumbs: IBreadcrumb[] = [];
    private navigationEnd$: Subscription;

    //#endregion

    //#region ctor

    constructor(private route: ActivatedRoute, private router: Router) {

    }

    //#endregion

    //#region Event cycles

    ngOnInit() {

        let root: ActivatedRoute = this.route.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
        this.deactivateLastItem();

        //subscribe to the NavigationEnd event
        this.navigationEnd$ = this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
            //set breadcrumbs
            let root: ActivatedRoute = this.route.root;
            this.breadcrumbs = this.getBreadcrumbs(root);
            this.deactivateLastItem();

        });

    }

    ngOnDestroy() {
        if (this.navigationEnd$ != null)
            this.navigationEnd$.unsubscribe();
    }

    //#endregion

    //#region private methods

    /**
    * Deactivate last item => user should not be able to go to the route is already in
    */
    private deactivateLastItem = () => {

        let i = this.breadcrumbs.length;
        if (this.breadcrumbs != null && i >= 1)
            this.breadcrumbs[i - 1].url = null

    }

    /**
     * Returns array of IBreadcrumb objects that represent the breadcrumb
     *
     * @class DetailComponent
     * @method getBreadcrumbs
     * @param {ActivateRoute} route
     * @param {string} url
     * @param {IBreadcrumb[]} breadcrumbs
     */
    private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
        const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";

        //get the child routes
        let children: ActivatedRoute[] = route.children;

        //return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }

        //iterate over each children
        for (let child of children) {
            //verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            //verify the custom data property "breadcrumb" is specified on the route
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }

            //get the route's URL segment
            let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

            //append route URL to URL
            url += `/${routeURL}`;

            //add breadcrumb
            let breadcrumb: IBreadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                params: child.snapshot.params,
                url: url
            };
            breadcrumbs.push(breadcrumb);

            //recursive
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }


    //#endregion

}

